import React from "react";

function Resultados() {
    return (
        <div className='container m-auto my-12'>
            <div className="flex flex-col items-center justify-between my-12">
                <h1 className="text-2xl font-times text-center mx-5"><strong>Resultados que puedes lograr</strong></h1>

                <p className="text-xl mx-5 font-times text-justify">
                    Cuando una persona, un líder o una organización decide trabajar en su mentalidad, su estructura y su forma de operar, los resultados comienzan a transformarse desde la raíz.
                    Algunas de las transformaciones que puedes experimentar a nivel personal, profesional o empresarial son:

                </p>

                <ul className="mx-6">
                    <li className="text-xl my-5 font-times"> <span className="text-green-500 text-xl">✓</span> Mayor claridad en propósito, visión y dirección</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Mentalidad más fuerte, enfocada y orientada a resultados</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Toma de decisiones más estratégicas y conscientes </li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Incremento en confianza, liderazgo y capacidad de ejecución</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Mayor enfoque, disciplina y productividad</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Mejora en la comunicación y alineación de equipos</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Desarrollo de liderazgo consciente en empresarios y líderes</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Equipos más comprometidos, responsables y orientados a objetivos</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Empresas con mayor claridad estratégica y cultura de crecimiento</li>
                    <li className="text-xl my-5 font-times"><span className="text-green-500 text-xl">✓</span> Resultados más sólidos y sostenibles en el tiempo</li>
                </ul>

                <p className="text-xl text-justify font-times mx-5 my-8">
                    Porque cuando se transforma la forma de pensar, se transforma la forma de actuar…
                    y cuando cambia la forma de actuar, cambian los resultados.<br />
                    El verdadero cambio no ocurre solo afuera.
                    Comienza en la mentalidad, se fortalece en el liderazgo y se refleja en los resultados.
                </p>

                <h1 className="text-2xl text-center font-times mx-5 my-8">
                    <strong>El Momento En Que Elevas Tu Mentalidad, Elevas Tu Liderazgo… Y Comienzas A Transformar Tus Resultados.</strong>
                </h1>
            </div>
        </div>
    )
}

export default Resultados;